import React from 'react';
import { MdUnfoldMore } from 'react-icons/md';
import { Text } from '../../../atoms';
import { TABLE_COLUMNS } from '../constants';

interface TableHeaderProps {
  sortType: string;
  onSort: (accessor: string) => void;
}

const TableHeader: React.FC<TableHeaderProps> = ({ sortType, onSort }) => {
  return (
    <thead>
      <tr>
        {TABLE_COLUMNS.map((column, index) => (
          <th key={index}>
            <button 
              type="button" 
              onClick={() => onSort(column.accessor)}
              className="sort-button"
            >
              <Text component="p" text={column.header} />
              <MdUnfoldMore />
            </button>
          </th>
        ))}
        <th>
          <Text component="p" text="Ações" className="alignLeft" />
        </th>
      </tr>
    </thead>
  );
};

export { TableHeader };
